import { useEffect, useState } from "react";
import "./Library.scss";
import { Navbar } from "./Navbar";

const CHANNEL_ID = "UCi0Zcnhtt4N8rmZRmUgI2vA";
const CACHE_KEY = "libraryVideos";
const YOUTUBE_API_KEY = process.env.REACT_APP_YOUTUBE_API_KEY || "YOUR_API_KEY_HERE";
// 24 hour cache to minimize API quota usage
const cacheTime = 24 * 60 * 60 * 1000; 

export function Library() {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchVideos = async () => {
      try {
        // Check cache first
        const cachedVideos = localStorage.getItem(CACHE_KEY);
        const cachedTime = localStorage.getItem(`${CACHE_KEY}_time`);
        if (cachedVideos && cachedTime && (Date.now() - parseInt(cachedTime)) < cacheTime) {
          if (isMounted) {
            setVideos(JSON.parse(cachedVideos));
            setLoading(false);
          }
          return;
        }

        // YouTube Data API v3
        const apiUrl = new URL("https://www.googleapis.com/youtube/v3/search");
        apiUrl.searchParams.append("key", YOUTUBE_API_KEY);
        apiUrl.searchParams.append("channelId", CHANNEL_ID);
        apiUrl.searchParams.append("part", "snippet");
        apiUrl.searchParams.append("order", "date");
        apiUrl.searchParams.append("maxResults", "15");
        apiUrl.searchParams.append("type", "video");

        const response = await fetch(apiUrl.toString());

        if (!response.ok) {
          throw new Error(`API error: ${response.status}`);
        }

        const data = await response.json();

        if (data.error) {
          throw new Error(`YouTube API error: ${data.error.message}`);
        }

        const vids = data.items.map((item) => ({
          id: item.id.videoId,
          title: item.snippet.title,
          thumbnail: item.snippet.thumbnails.medium.url,
          link: `https://www.youtube.com/watch?v=${item.id.videoId}`,
        }));

        // Cache the videos with timestamp
        if (isMounted) {
          localStorage.setItem(CACHE_KEY, JSON.stringify(vids));
          localStorage.setItem(`${CACHE_KEY}_time`, Date.now().toString());
          setVideos(vids);
          setError(null);
        }
      } catch (err) {
        console.error("Error fetching videos:", err);
        if (isMounted) {
          setError("Failed to load videos. Check your API key.");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    fetchVideos();

    return () => {
      isMounted = false;
    };
  }, []);

  if (loading) return <div> <Navbar />Loading videos...</div>;
  if (error) return <div> <Navbar /> Page is under construction</div>;

  return (
    <>
      <Navbar />
      <div className="library">
        <div className="title">
          <h1>Library of Previous Messages</h1>
        </div>
        <ul>
          {videos.map((video) => (
            <li key={video.id}>
              <a
                href={video.link}
                target="_blank"
                rel="noopener noreferrer"
              >
                <img
                  src={video.thumbnail}
                  alt={video.title}
                />
                <p>{video.title}</p>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}
